import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import Services from "@/components/Services";
import Customize from "@/components/Customize";
import Compliance from "@/components/Compliance";
import WhyUs from "@/components/WhyUs";
import Process from "@/components/Process";
import Examples from "@/components/Examples";
import Faq from "@/components/Faq";
import FinalCta from "@/components/FinalCta";
import Footer from "@/components/Footer";
import FloatingWhatsapp from "@/components/FloatingWhatsapp";
import CookieBanner from "@/components/CookieBanner";
import { useSeo } from "@/hooks/useSeo";

const HOME_SEO = {
  title: "Chile Datos Pro | Bases de Datos B2B y Contactos de Empresas en Chile",
  description:
    "Bases de datos B2B de empresas en Chile. Contactos verificados, segmentados por rubro y región, en cumplimiento con la nueva Ley 21.719 de Protección de Datos. Cotiza por WhatsApp.",
  canonical: "https://chiledatospro.cl/",
};

const HOME_FAQ_LD = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: [
    ["¿Cómo se recopilan los datos?", "Obtenemos los datos desde fuentes públicas, registros oficiales y scraping legalmente permitido. Siempre cuidamos que la información esté actualizada, limpia y lista para usar — y en coherencia con la Ley 21.719."],
    ["¿Los contactos cumplen con la nueva Ley 21.719?", "Sí. Trabajamos únicamente con datos de carácter empresarial (B2B) provenientes de fuentes públicas legales. Cada base incluye documentación de origen para garantizar trazabilidad."],
    ["¿Cuánto cuesta el servicio?", "Los precios varían según el tamaño y la complejidad del pedido. Escríbenos por WhatsApp con lo que necesitas y te enviamos una cotización rápida y clara."],
    ["¿En cuánto tiempo entregan las bases?", "Bases estándar pueden entregarse en menos de 24 horas. Bases personalizadas pueden tardar entre 1 y 3 días hábiles."],
    ["¿La información está actualizada?", "Sí. Nuestra prioridad es entregar datos útiles y actuales. Cada base de datos tiene una fecha de actualización incluida."],
    ["¿En qué formato entregan las bases?", "Entregamos en el formato que necesites: Excel, CSV, SQL, Google Sheets o el que tu equipo utilice."],
    ["¿Ofrecen garantía sobre los datos?", "Sí. Si encuentras correos o teléfonos desactualizados dentro de un rango razonable, los reemplazamos sin costo adicional."],
    ["¿Trabajan con empresas de cualquier rubro?", "Sí. Atendemos a empresas de todos los sectores en Chile: construcción, retail, servicios profesionales, inmobiliario, salud, exportación, entre otros."],
  ].map(([q, a]) => ({
    "@type": "Question",
    name: q,
    acceptedAnswer: { "@type": "Answer", text: a },
  })),
};

export default function Home() {
  useSeo(HOME_SEO);

  return (
    <div className="App relative">
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(HOME_FAQ_LD) }}
      />
      <Navbar />
      <main>
        <Hero />
        <Services />
        <Customize />
        <Compliance />
        <WhyUs />
        <Process />
        <Examples />
        <Faq />
        <FinalCta />
      </main>
      <Footer />
      <FloatingWhatsapp />
      <CookieBanner />
    </div>
  );
}
